<div class="profile-wrapper">
    <div class="profile-card">

        <div class="logo-section">
            <div class="logo-upload-area" (click)="logoInput.click()">
                <div class="logo-preview" *ngIf="!logoPreview">
                    <div class="logo-placeholder">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5">
                            <rect x="3" y="3" width="18" height="18" rx="3" />
                            <circle cx="8.5" cy="8.5" r="1.5" />
                            <polyline points="21 15 16 10 5 21" />
                        </svg>
                    </div>
                </div>
                <img *ngIf="logoPreview" [src]="getImagePath(logoPreview)" alt="Company Logo" class="logo-img" />
                <div class="logo-info">
                    <span class="logo-label">{{ 'Company Logo' | translate }}</span>
                    <span class="logo-hint">{{ 'png, jpg, jpeg · Under 5 MB' | translate }}</span>
                </div>
                <input type="file" #logoInput accept="image/*" (change)="onLogoChange($event)" hidden />
            </div>
            <div class="logo-actions">
                <button class="btn-delete" *ngIf="logoPreview" (click)="removeLogo()">{{ 'Remove Logo' | translate
                    }}</button>
                <button class="btn-delete" (click)="goToProfile()">{{ 'View Profile' | translate
                    }}</button>
            </div>

        </div>

        <div class="divider"></div>

        <div class="form-row">
            <div class="form-group">
                <label class="form-label">
                    {{ 'Full Name' | translate }} <span class="required-star">*</span>
                </label>
                <div class="input-wrapper" [class.input-error]="touched.fullName && errors.fullName">
                    <svg class="input-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                    </svg>
                    <input type="text" class="form-input" [placeholder]="'Full name' | translate"
                        [(ngModel)]="profile.fullName" (blur)="onBlur('fullName')" />
                </div>
                <span class="field-error" *ngIf="touched.fullName && errors.fullName">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2.5">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="12" />
                        <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                    {{ errors.fullName | translate }}
                </span>
            </div>

            <div class="form-group">
                <label class="form-label">{{ 'Phone Number' | translate }}</label>
                <div class="input-wrapper phone-wrapper" [class.input-error]="touched.phone && errors.phone">
                    <div class="phone-flag" (click)="toggleCountryDropdown()" #countryTrigger>
                        <img [src]="selectedCountry.flag" [alt]="selectedCountry.code" class="flag-img" />
                        <span class="country-code" style="font-size: 13px; font-weight: 500;">{{ selectedCountry.dial
                            }}</span>
                        <svg class="chevron-icon" [class.rotated]="showCountryDropdown" width="12" height="12"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            style="transition: transform 0.2s; margin-inline-start: 4px;">
                            <polyline points="6 9 12 15 18 9" />
                        </svg>
                    </div>
                    <div class="country-dropdown" *ngIf="showCountryDropdown">
                        <div class="country-search-wrapper">
                            <svg class="country-search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2">
                                <circle cx="11" cy="11" r="8" />
                                <line x1="21" y1="21" x2="16.65" y2="16.65" />
                            </svg>
                            <input type="text" class="country-search-input"
                                [placeholder]="'Search country...' | translate" [(ngModel)]="countrySearch"
                                [ngModelOptions]="{ standalone: true }" (click)="$event.stopPropagation()" />
                        </div>
                        <ul class="country-list">
                            <li *ngFor="let country of filteredCountries" (click)="selectCountry(country, $event)"
                                [class.active]="selectedCountry.code === country.code">
                                <img [src]="country.flag" [alt]="country.code" class="flag-img" />
                                <span class="country-name">{{ country.name }}</span>
                                <span class="country-dial">{{ country.dial }}</span>
                            </li>
                        </ul>
                    </div>
                    <input type="tel" class="form-input" [placeholder]="'01012345678' | translate"
                        [(ngModel)]="profile.phone" (keydown)="onPhoneKeyDown($event)" (blur)="onBlur('phone')" />
                </div>
                <span class="field-error" *ngIf="touched.phone && errors.phone">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2.5">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="12" />
                        <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                    {{ errors.phone | translate }}
                </span>
            </div>
        </div>

        <div class="form-row">
            <div class="form-group">
                <label class="form-label">
                    {{ 'Email' | translate }} <span class="required-star">*</span>
                </label>
                <div class="input-wrapper" [class.input-error]="touched.email && errors.email">
                    <svg class="input-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                        <polyline points="22,6 12,13 2,6" />
                    </svg>
                    <input type="email" class="form-input" [placeholder]="'example@email.com' | translate"
                        [(ngModel)]="profile.email" (blur)="onBlur('email')" />
                </div>
                <span class="field-error" *ngIf="touched.email && errors.email">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2.5">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="12" />
                        <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                    {{ errors.email | translate }}
                </span>
            </div>

            <div class="form-group">
                <label class="form-label">{{ 'Website' | translate }}</label>
                <div class="input-wrapper" [class.input-error]="touched.website && errors.website">
                    <svg class="input-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="2" y1="12" x2="22" y2="12" />
                        <path
                            d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                    </svg>
                    <input type="url" class="form-input" [placeholder]="'https://yourcompany.com' | translate"
                        [(ngModel)]="profile.website" (blur)="onBlur('website')" />
                </div>
                <span class="field-error" *ngIf="touched.website && errors.website">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2.5">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="12" />
                        <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                    {{ errors.website | translate }}
                </span>
            </div>
        </div>

        <div class="form-row form-row-four">
            <div class="form-group">
                <label class="form-label">{{ 'Founded In' | translate }}</label>
                <div class="input-wrapper">
                    <svg class="input-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                        <line x1="16" y1="2" x2="16" y2="6" />
                        <line x1="8" y1="2" x2="8" y2="6" />
                        <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                    <input type="number" class="form-input" [placeholder]="'e.g. 2015' | translate"
                        [(ngModel)]="profile.foundedIn" />
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">{{ 'Organisation Type' | translate }}</label>
                <div class="input-wrapper">
                    <svg class="input-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                        <polyline points="9 22 9 12 15 12 15 22" />
                    </svg>
                    <input type="text" class="form-input" [placeholder]="'e.g. Private company' | translate"
                        [(ngModel)]="profile.orgType" />
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">{{ 'Team Size' | translate }}</label>
                <div class="input-wrapper">
                    <svg class="input-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <input type="text" class="form-input" [placeholder]="'e.g. 10–50' | translate"
                        [(ngModel)]="profile.teamSize" />
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">{{ 'Industry' | translate }}</label>
                <div class="input-wrapper">
                    <svg class="input-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <rect x="2" y="7" width="20" height="14" rx="2" />
                        <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
                    </svg>
                    <input type="text" class="form-input" [placeholder]="'e.g. Software' | translate"
                        [(ngModel)]="profile.activityType" />
                </div>
            </div>
        </div>

        <div class="form-group full-width">
            <label class="form-label">{{ 'About Company' | translate }}</label>
            <div class="quill-wrapper">
                <div #quillEditor></div>
            </div>
        </div>

        <div class="form-group full-width">
            <label class="form-label">{{ 'Benefits' | translate }}</label>
            <div class="quill-wrapper">
                <div #quillBenefits></div>
            </div>
        </div>

        <div class="form-group full-width">
            <label class="form-label">{{ 'Company Vision' | translate }}</label>
            <!-- REPLACE with: -->
            <div class="quill-wrapper">
                <div #quillVision></div>
            </div>
        </div>

        <div class="form-group full-width">
            <label class="form-label">{{ 'Cover Image' | translate }}</label>
            <div class="cover-upload-zone" (dragover)="onDragOver($event)" (dragleave)="onDragLeave()"
                (drop)="onDrop($event)" [class.drag-active]="isDragging">
                <div class="cover-upload-previews" *ngIf="coverPreviews.length > 0">
                    <div class="cover-thumb" *ngFor="let img of coverPreviews; let i = index">
                        <img [src]="getImagePath(img)" alt="Cover" />
                        <button class="remove-thumb" (click)="removeCover(i)">×</button>
                    </div>
                </div>
                <div class="upload-placeholder">
                    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="1.5">
                        <polyline points="16 16 12 12 8 16" />
                        <line x1="12" y1="12" x2="12" y2="21" />
                        <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
                    </svg>
                    <p class="upload-text">{{ 'Drag and drop images here' | translate }}</p>
                    <p class="upload-sub">{{ 'Or click to browse' | translate }}</p>
                    <button class="btn-upload" (click)="coverInput.click()">{{ 'Upload' | translate }}</button>
                </div>
                <input type="file" #coverInput accept="image/*" multiple (change)="onCoverChange($event)" hidden />
            </div>
        </div>

        <div class="form-group full-width">
            <label class="form-label form-label-section">{{ 'Legal Documents' | translate }}</label>
            <div class="form-row">
                <div class="form-group">
                    <label class="form-label">{{ 'Tax Registration Document' | translate }}</label>
                    <div class="doc-upload-box" (click)="taxDocInput.click()">
                        <ng-container *ngIf="!taxDocName && !profile.taxRegistrationDocument">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="1.5">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                <polyline points="14 2 14 8 20 8" />
                                <line x1="12" y1="18" x2="12" y2="12" />
                                <line x1="9" y1="15" x2="15" y2="15" />
                            </svg>
                            <span class="doc-upload-label">{{ 'Click to upload' | translate }}</span>
                            <span class="doc-upload-hint">{{ 'PDF, JPG, PNG · Max 10 MB' | translate }}</span>
                        </ng-container>
                        <ng-container *ngIf="taxDocName || profile.taxRegistrationDocument">
                            <div class="doc-file-row" (click)="$event.stopPropagation()">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#5037aa"
                                    stroke-width="2">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                    <polyline points="14 2 14 8 20 8" />
                                </svg>
                                <span class="doc-file-name">{{ taxDocName }}</span>
                                <div class="doc-actions">
                                    <button class="doc-btn doc-btn-view"
                                        *ngIf="profile.taxRegistrationDocument && !taxDocFile"
                                        (click)="openDocument(profile.taxRegistrationDocument!, taxDocName!)">
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2">
                                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                            <circle cx="12" cy="12" r="3" />
                                        </svg>
                                        {{ 'View' | translate }}
                                    </button>
                                    <button class="doc-btn doc-btn-download"
                                        *ngIf="profile.taxRegistrationDocument && !taxDocFile"
                                        (click)="downloadDocument(profile.taxRegistrationDocument!, taxDocName!)">
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2">
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                            <polyline points="7 10 12 15 17 10" />
                                            <line x1="12" y1="15" x2="12" y2="3" />
                                        </svg>
                                        {{ 'Download' | translate }}
                                    </button>
                                    <button class="doc-btn doc-btn-remove" (click)="removeTaxDoc()">
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2">
                                            <polyline points="3 6 5 6 21 6" />
                                            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                                            <path d="M10 11v6M14 11v6" />
                                        </svg>
                                        {{ 'Remove' | translate }}
                                    </button>
                                </div>
                            </div>
                            <span class="doc-replace-hint">{{ 'Click anywhere to replace' | translate }}</span>
                        </ng-container>
                    </div>
                    <input type="file" #taxDocInput accept=".pdf,image/*" (change)="onTaxDocChange($event)" hidden />
                </div>

                <div class="form-group">
                    <label class="form-label">{{ 'Commercial Registration Document' | translate }}</label>
                    <div class="doc-upload-box" (click)="commercialDocInput.click()">
                        <ng-container *ngIf="!commercialDocName && !profile.commercialRegistrationDocument">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="1.5">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                <polyline points="14 2 14 8 20 8" />
                                <line x1="12" y1="18" x2="12" y2="12" />
                                <line x1="9" y1="15" x2="15" y2="15" />
                            </svg>
                            <span class="doc-upload-label">{{ 'Click to upload' | translate }}</span>
                            <span class="doc-upload-hint">{{ 'PDF, JPG, PNG · Max 10 MB' | translate }}</span>
                        </ng-container>
                        <ng-container *ngIf="commercialDocName || profile.commercialRegistrationDocument">
                            <div class="doc-file-row" (click)="$event.stopPropagation()">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#5037aa"
                                    stroke-width="2">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                    <polyline points="14 2 14 8 20 8" />
                                </svg>
                                <span class="doc-file-name">{{ commercialDocName }}</span>
                                <div class="doc-actions">
                                    <button class="doc-btn doc-btn-view"
                                        *ngIf="profile.commercialRegistrationDocument && !commercialDocFile"
                                        (click)="openDocument(profile.commercialRegistrationDocument!, commercialDocName!)">
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2">
                                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                            <circle cx="12" cy="12" r="3" />
                                        </svg>
                                        {{ 'View' | translate }}
                                    </button>
                                    <button class="doc-btn doc-btn-download"
                                        *ngIf="profile.commercialRegistrationDocument && !commercialDocFile"
                                        (click)="downloadDocument(profile.commercialRegistrationDocument!, commercialDocName!)">
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2">
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                            <polyline points="7 10 12 15 17 10" />
                                            <line x1="12" y1="15" x2="12" y2="3" />
                                        </svg>
                                        {{ 'Download' | translate }}
                                    </button>
                                    <button class="doc-btn doc-btn-remove" (click)="removeCommercialDoc()">
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2">
                                            <polyline points="3 6 5 6 21 6" />
                                            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                                            <path d="M10 11v6M14 11v6" />
                                        </svg>
                                        {{ 'Remove' | translate }}
                                    </button>
                                </div>
                            </div>
                            <span class="doc-replace-hint">{{ 'Click anywhere to replace' | translate }}</span>
                        </ng-container>
                    </div>
                    <input type="file" #commercialDocInput accept=".pdf,image/*"
                        (change)="onCommercialDocChange($event)" hidden />
                </div>
            </div>
        </div>

        <div class="doc-preview-overlay" *ngIf="previewUrl" (click)="closePreview()">
            <div class="doc-preview-modal" (click)="$event.stopPropagation()">
                <div class="doc-preview-header">
                    <span class="doc-preview-title">{{ previewFileName }}</span>
                    <button class="doc-preview-close" (click)="closePreview()">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.5">
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>
                </div>
                <div class="doc-preview-body">
                    <img *ngIf="previewIsImage" [src]="previewUrl" alt="Document preview" class="doc-preview-img" />
                    <iframe *ngIf="!previewIsImage" [src]="previewUrl" class="doc-preview-pdf"></iframe>
                </div>
            </div>
        </div>

        <div class="form-group full-width">
            <label class="form-label form-label-section">{{ 'Social Media' | translate }}</label>
            <div class="social-links-grid">

                <div class="form-group">
                    <label class="form-label">{{ 'Facebook' | translate }}</label>
                    <div class="input-wrapper" [class.input-error]="touched.facebook && errors.facebook">
                        <svg class="input-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                        </svg>
                        <input type="url" class="form-input" [placeholder]="'https://facebook.com/yourpage' | translate"
                            [(ngModel)]="profile.facebook" (blur)="onBlur('facebook')" />
                    </div>
                    <span class="field-error" *ngIf="touched.facebook && errors.facebook">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.5">
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="12" />
                            <line x1="12" y1="16" x2="12.01" y2="16" />
                        </svg>
                        {{ errors.facebook | translate }}
                    </span>
                </div>

                <div class="form-group">
                    <label class="form-label">{{ 'YouTube' | translate }}</label>
                    <div class="input-wrapper" [class.input-error]="touched.youtube && errors.youtube">
                        <svg class="input-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path
                                d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.95C5.12 20 12 20 12 20s6.88 0 8.59-.47a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z" />
                            <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="white" />
                        </svg>
                        <input type="url" class="form-input"
                            [placeholder]="'https://youtube.com/@yourchannel' | translate" [(ngModel)]="profile.youtube"
                            (blur)="onBlur('youtube')" />
                    </div>
                    <span class="field-error" *ngIf="touched.youtube && errors.youtube">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.5">
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="12" />
                            <line x1="12" y1="16" x2="12.01" y2="16" />
                        </svg>
                        {{ errors.youtube | translate }}
                    </span>
                </div>

                <div class="form-group">
                    <label class="form-label">{{ 'Snapchat' | translate }}</label>
                    <div class="input-wrapper" [class.input-error]="touched.snapchat && errors.snapchat">
                        <svg class="input-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path
                                d="M12 2C6.48 2 2 6.03 2 11c0 2.7 1.15 5.13 3 6.84V21l3.5-2c1.04.28 2.13.44 3.5.44s2.46-.16 3.5-.44L19 21v-3.16C20.85 16.13 22 13.7 22 11c0-4.97-4.48-9-10-9z" />
                        </svg>
                        <input type="url" class="form-input"
                            [placeholder]="'https://snapchat.com/add/username' | translate"
                            [(ngModel)]="profile.snapchat" (blur)="onBlur('snapchat')" />
                    </div>
                    <span class="field-error" *ngIf="touched.snapchat && errors.snapchat">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.5">
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="12" />
                            <line x1="12" y1="16" x2="12.01" y2="16" />
                        </svg>
                        {{ errors.snapchat | translate }}
                    </span>
                </div>

                <div class="form-group">
                    <label class="form-label">{{ 'X (Twitter)' | translate }}</label>
                    <div class="input-wrapper" [class.input-error]="touched.twitter && errors.twitter">
                        <svg class="input-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path
                                d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                        </svg>
                        <input type="url" class="form-input" [placeholder]="'https://x.com/yourhandle' | translate"
                            [(ngModel)]="profile.twitter" (blur)="onBlur('twitter')" />
                    </div>
                    <span class="field-error" *ngIf="touched.twitter && errors.twitter">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.5">
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="12" />
                            <line x1="12" y1="16" x2="12.01" y2="16" />
                        </svg>
                        {{ errors.twitter | translate }}
                    </span>
                </div>

                <div class="form-group">
                    <label class="form-label">{{ 'LinkedIn' | translate }}</label>
                    <div class="input-wrapper" [class.input-error]="touched.linkedin && errors.linkedin">
                        <svg class="input-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                            <rect x="2" y="9" width="4" height="12" />
                            <circle cx="4" cy="4" r="2" />
                        </svg>
                        <input type="url" class="form-input"
                            [placeholder]="'https://linkedin.com/company/yourcompany' | translate"
                            [(ngModel)]="profile.linkedin" (blur)="onBlur('linkedin')" />
                    </div>
                    <span class="field-error" *ngIf="touched.linkedin && errors.linkedin">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.5">
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="12" />
                            <line x1="12" y1="16" x2="12.01" y2="16" />
                        </svg>
                        {{ errors.linkedin | translate }}
                    </span>
                </div>

                <div class="form-group">
                    <label class="form-label">{{ 'Instagram' | translate }}</label>
                    <div class="input-wrapper" [class.input-error]="touched.instagram && errors.instagram">
                        <svg class="input-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2">
                            <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                            <circle cx="12" cy="12" r="4" />
                            <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
                        </svg>
                        <input type="url" class="form-input"
                            [placeholder]="'https://instagram.com/yourprofile' | translate"
                            [(ngModel)]="profile.instagram" (blur)="onBlur('instagram')" />
                    </div>
                    <span class="field-error" *ngIf="touched.instagram && errors.instagram">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.5">
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="12" />
                            <line x1="12" y1="16" x2="12.01" y2="16" />
                        </svg>
                        {{ errors.instagram | translate }}
                    </span>
                </div>

            </div>
        </div>

        <div class="action-bar">
            <span class="feedback-success" *ngIf="saveSuccess">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <polyline points="20 6 9 17 4 12" />
                </svg>
                {{ 'Changes saved successfully' | translate }}
            </span>
            <span class="feedback-error" *ngIf="saveError">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                {{ saveError | translate }}
            </span>
            <div class="action-buttons">
                <button class="btn-cancel" (click)="onCancel()" [disabled]="isSaving">{{ 'Cancel' | translate
                    }}</button>
                <button class="btn-save" (click)="onSave()" [disabled]="isSaving">
                    <svg *ngIf="isSaving" class="spinner" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2.5">
                        <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4" />
                    </svg>
                    {{ isSaving ? ('Saving…' | translate) : ('Save Changes' | translate) }}
                </button>
            </div>
        </div>

    </div>
</div>